import { formatToPersianAddComma, parseToEnRemoveComma } from "../../utils/CommaSeparator";
export const calculateSumOfEachRow = (tableArray = []) => {

    //debugger
    const tableData = [...tableArray];
    tableData.forEach((singleRow, index) => {

        let { AmountOfService, Quantity } = singleRow;
        if (AmountOfService === undefined) AmountOfService = 0
        if (Quantity === undefined) Quantity = 0

        singleRow.total = (parseInt(parseToEnRemoveComma(AmountOfService))) * parseInt(parseToEnRemoveComma(Quantity))
        singleRow.total = formatToPersianAddComma(singleRow.total)
    })
    return tableData
}
export const updateTableCellHandler = (tableArray, TypeOfService, field, newValue) => {

    const table = [...tableArray];

    table.forEach((row, index) => {

        if (row.TypeOfService === TypeOfService) {
            row[field] = newValue
            // table.splice(index, 1);
        }
    })
    return table

}
export const myCustomCelEditFunction = (sendData, setSendData, cell, field, newValue) => {
    const TypeOfService = cell.getData().TypeOfService;
    const tableData = updateTableCellHandler(sendData.tableData, TypeOfService, field, newValue);
    setSendData({ tableData });
}